<template>
  <div class="project-manage-page">
    <el-card>
      <el-form :model="filter" inline size="small">
        <el-form-item label="项目名称">
          <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search"
            >搜索</el-button
          >
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button
        type="primary"
        size="small"
        style="margin-bottom: 10px"
        @click="add"
        >添加</el-button
      >
      <el-table :data="list" border>
        <el-table-column
          align="center"
          label="排序号"
          prop="sortNum"
          min-width="70"
        />
        <el-table-column min-width="150" align="center" label="项目名称" prop="projectName" />
        <el-table-column
          align="center"
          label="状态"
          prop="status"
          min-width="80"
        >
          <template v-slot="{ row: { status } }">
            <span v-if="status === 1">启用</span>
            <span v-else-if="status === 2">停用</span>
          </template>
        </el-table-column>
        <el-table-column min-width="210" align="center" label="备注" prop="remarks" />
        <el-table-column
          align="center"
          label="操作时间"
          prop="lastUpdateDate"
          min-width="160"
        />
        <el-table-column
          align="center"
          label="最后操作人"
          prop="lastUpdateName"
          min-width="140"
        />
        <el-table-column align="center" label="操作" min-width="110">
          <template v-slot="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button
              v-if="row.status === 1"
              type="text"
              @click="statusAmend(row)"
              >停用</el-button
            >
            <el-button
              v-else-if="row.status === 2"
              type="text"
              @click="statusAmend(row)"
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        size="small"
        class="demo-ruleForm"
      >
        <el-form-item label="项目名称" prop="projectName">
          <el-input
            v-model="ruleForm.projectName"
            maxlength="20"
            placeholder="请输入项目名称"
          />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input
            v-model.number="ruleForm.sortNum"
            maxlength="6"
            @input="sortNumValue"
            placeholder="请输入排序号"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="ruleForm.remarks"
            maxlength="50"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="submit('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPageList, updateProject, addProject } from "@/api/product/project";
export default {
  name: "ProjectManage",
  data() {
    return {
      filter: {
        page: 1,
        limit: 10,
        id: "",
      },
      total: 0,
      list: [],
      title: "",
      dialogVisible: false,
      row: null,
      ruleForm: {
        id: '', // 主键
        projectName: '', // 项目名称
        status: '', // 1启用2停用
        sortNum: '', // 排序号
        remarks: '', // 备注
        insertDate: '', // 创建时间
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        status: [
          // {required: true, message: '请输入1启用2停用', trigger: 'blur'}
        ],
        sortNum: [
          {required: true, message: '请输入排序号', trigger: 'blur'}
        ],
        remarks: [
          // {required: true, message: '请输入备注', trigger: 'blur'}
        ],
        insertDate: [
          // {required: true, message: '请输入创建时间', trigger: 'blur'}
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    sortNumValue(payload) {
      this.$nextTick(() => {
        this.$set(this.ruleForm, "sortNum", payload.replace(/[^0-9]/g, ""));
      });
    },
    // 搜索
    search() {
      this.filter.page = 1;
      this.getList();
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = null;
      });
      this.filter.page = 1;
      this.filter.limit = 10;
      this.getList();
    },
    // 列表
    async getList() {
      const res = await getPageList(this.filter);
      if (res.code !== 0) return this.$message.error(res.message);
      this.list = res.data.records;
      this.total = +res.data.total;
    },
    // 修改状态
    statusAmend(row) {
      let operateStatus = "";
      let status = 1;
      switch (row.status) {
        case 1:
          operateStatus = "停用";
          status = 2;
          break;
        case 2:
          operateStatus = "启用";
          status = 1;
          break;
      }
      this.$confirm(`确认${operateStatus}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await updateProject({ id: row.id, status });
          if (res.code !== 0) return this.$message.error(res.message);
          this.$message.success(`${operateStatus}成功!`);
          this.getList();
        })
        .catch(() => {});
    },
    add() {
      this.title = "添加";
      this.dialogVisible = true;
      // this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
    edit(row) {
      this.title = "编辑";
      this.row = row;
      // this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.$nextTick(() => {
        Object.keys(this.ruleForm).forEach((key) => {
          this.ruleForm[key] = row[key];
        });
      })
      this.dialogVisible = true;
    },
    // 提交 新增 / 编辑
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const sendObj = { ...this.ruleForm };
          let res;
          if (this.row) {
            // 编辑
            sendObj.id = this.row.id;
            res = await updateProject(sendObj);
          } else {
            // 新增
            res = await addProject(sendObj);
          }
          if (res.code !== 0) return this.$message.error(res.message);
          this.$message.success("操作成功!");
          this.handleClose();
          this.getList();
        }
      });
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.row = null;
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = ''
      });
    },
    handleSizeChange(v) {
      this.filter.page = 1;
      this.filter.limit = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.filter.page = v;
      this.getList();
    },
  },
};
</script>

<style lang="scss">
.project-manage-page {
  .clear {
    clear: both;
  }
}
</style>
